import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './video-meta-data-keywords.reducer';
import { IVideoMetaDataKeywords } from 'app/shared/model/video-meta-data-keywords.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IVideoMetaDataKeywordsProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const VideoMetaDataKeywords = (props: IVideoMetaDataKeywordsProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { videoMetaDataKeywordsList, match, loading } = props;
  return (
    <div>
      <h2 id="video-meta-data-keywords-heading">
        Video Meta Data Keywords
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Video Meta Data Keywords
        </Link>
      </h2>
      <div className="table-responsive">
        {videoMetaDataKeywordsList && videoMetaDataKeywordsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Keyword Name</th>
                <th>Video Meta Data</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {videoMetaDataKeywordsList.map((videoMetaDataKeywords, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${videoMetaDataKeywords.id}`} color="link" size="sm">
                      {videoMetaDataKeywords.id}
                    </Button>
                  </td>
                  <td>{videoMetaDataKeywords.keywordName}</td>
                  <td>
                    {videoMetaDataKeywords.videoMetaData ? (
                      <Link to={`video-meta-data/${videoMetaDataKeywords.videoMetaData.id}`}>{videoMetaDataKeywords.videoMetaData.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${videoMetaDataKeywords.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${videoMetaDataKeywords.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${videoMetaDataKeywords.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Video Meta Data Keywords found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ videoMetaDataKeywords }: IRootState) => ({
  videoMetaDataKeywordsList: videoMetaDataKeywords.entities,
  loading: videoMetaDataKeywords.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoMetaDataKeywords);
